import { Box, Text, VStack } from '@chakra-ui/react';
import { ReactElement } from 'react';

type Props = {
  label: string;
  value: string;
};

export const WorksheetClassSummaryStatCard = ({ label, value }: Props): ReactElement => (
  <Box
    flex="1"
    minW="0"
    bg="background.canvas"
    border="1px solid"
    borderColor="border.accent"
    borderRadius="l"
    px="s"
    py="xs"
  >
    <VStack align="stretch" gap="xs">
      <Text textStyle="body.xs.regular" color="text.tertiary">
        {label}
      </Text>
      <Text textStyle="body.m.medium" color="text.primary">
        {value}
      </Text>
    </VStack>
  </Box>
);
